var $b87e4e11de3666fc$exports = {};
{
    let vid = document.getElementsByTagName('video');
    if (vid.length > 0) vid[0].addEventListener('ended', function() {
        vid[0].load();
        vid[0].play();
    });
}

//# sourceMappingURL=hero.js.map
